import { defineMessages } from 'react-intl';

export default defineMessages({

  thisSectionRelatesToExpenses: {
    id: 'fastCover.collisionDamageStarrStep.thisSectionRelatesToExpenses',
    defaultMessage: 'This section relates to expenses resulting from your rental vehicle being stolen or damaged.',
  },

  cityOrTown: {
    id: 'fastCover.collisionDamageStarrStep.cityOrTown',
    defaultMessage: 'City or Town',
  },

  country: {
    id: 'fastCover.collisionDamageStarrStep.country',
    defaultMessage: 'Country',
  },

  postalCode: {
    id: 'fastCover.collisionDamageStarrStep.postalCode',
    defaultMessage: 'Postal Code',
  },

  phoneNumber: {
    id: 'fastCover.collisionDamageStarrStep.phoneNumber',
    defaultMessage: 'Phone Number',
  },

  currency: {
    id: 'fastCover.collisionDamageStarrStep.currency',
    defaultMessage: 'Currency',
  },

  yes: {
    id: 'fastCover.collisionDamageStarrStep.yes',
    defaultMessage: 'Yes',
  },

  no: {
    id: 'fastCover.collisionDamageStarrStep.no',
    defaultMessage: 'No',
  },

  addItem: {
    id: 'fastCover.collisionDamageStarrStep.addItem',
    defaultMessage: 'Add Expense',
  },

  itemWithIdx: {
    id: 'fastCover.collisionDamageStarrStep.itemWithIdx',
    defaultMessage: 'Item(s) {idx}',
  },

  item: {
    id: 'fastCover.collisionDamageStarrStep.item',
    defaultMessage: 'Item',
  },

  isRequired: {
    id: 'fastCover.collisionDamageStarrStep.isRequired',
    defaultMessage: "'{defaultMessage}' is required",
  },

  checkEventDate: {
    id: 'fastCover.collisionDamageStarrStep.checkEventDate',
    defaultMessage: "'{defaultMessage}' cannot be in the future.",
  },

  areYouClaimingForRentalCarDamage: {
    id: 'fastCover.collisionDamageStarrStep.areYouClaimingForRentalCarDamage',
    defaultMessage: 'Are you claiming for Rental Car Damage?',
  },

  travelSupplierOrProviderInformation: {
    id: 'fastCover.collisionDamageStarrStep.travelSupplierOrProviderInformation',
    defaultMessage: 'Travel Supplier / Provider Information',
  },

  nameOfTourOperatorOrCruiseOrLineOrAirline: {
    id: 'fastCover.collisionDamageStarrStep.travelSupplierOrProviderInformation',
    defaultMessage: 'Name of Tour Operator/Cruise Line/Airline you were traveling with:',
  },

  lossInformation: {
    id: 'fastCover.collisionDamageStarrStep.lossInformation',
    defaultMessage: 'Loss Information',
  },

  otherInsuranceAuthorization: {
    id: 'fastCover.collisionDamageStarrStep.otherInsuranceAuthorization',
    defaultMessage: 'OTHER INSURANCE / AUTHORISATION:',
  },

  companyName: {
    id: 'fastCover.collisionDamageStarrStep.companyName',
    defaultMessage: 'Company Name',
  },

  address: {
    id: 'fastCover.collisionDamageStarrStep.address',
    defaultMessage: 'Address',
  },

  typeOfPolicy: {
    id: 'fastCover.collisionDamageStarrStep.typeOfPolicy',
    defaultMessage: 'Type Of Policy',
  },

  policy: {
    id: 'fastCover.collisionDamageStarrStep.policy',
    defaultMessage: 'Policy',
  },

  policyNumber: {
    id: 'fastCover.collisionDamageStarrStep.policyNumber',
    defaultMessage: 'Policy Number',
  },

  contact: {
    id: 'fastCover.collisionDamageStarrStep.contactF',
    defaultMessage: 'Contact',
  },

  phone: {
    id: 'fastCover.collisionDamageStarrStep.phone',
    defaultMessage: 'Phone',
  },

  origination: {
    id: 'fastCover.collisionDamageStarrStep.origination',
    defaultMessage: 'Origination',
  },

  flightNumber: {
    id: 'fastCover.collisionDamageStarrStep.flightNumber',
    defaultMessage: 'Flight Number',
  },

  airCarrier: {
    id: 'fastCover.collisionDamageStarrStep.airCarrier',
    defaultMessage: 'Air Carrier',
  },

  destination: {
    id: 'fastCover.collisionDamageStarrStep.destination',
    defaultMessage: 'Destination',
  },

  companyNameLoss: {
    id: 'fastCover.collisionDamageStarrStep.companyNameLoss',
    defaultMessage: 'Company name (airline/hotel/cruse/travel agent/ect.)',
  },

  amountPaidLoss: {
    id: 'fastCover.collisionDamageStarrStep.amountPaidLoss',
    defaultMessage: 'Amount Paid (total for all insureds)',
  },

  amountOfLoss: {
    id: 'fastCover.collisionDamageStarrStep.amountOfLoss',
    defaultMessage: 'Amount of Loss (non-refundable amount)',
  },

  howMuchReceivedReimbursement: {
    id: 'fastCover.collisionDamageStarrStep.howMuchReceivedReimbursement',
    defaultMessage: 'How much?',
  },

  haveYouReceivedReimbursement: {
    id: 'fastCover.collisionDamageStarrStep.haveYouReceivedReimbursement',
    defaultMessage: 'Have you received reimbursement?',
  },

  delayInformationWithIdx: {
    id: 'fastCover.collisionDamageStarrStep.delayInformationWithIdx',
    defaultMessage: 'Delay information {idx}',
  },

  fromWhom: {
    id: 'fastCover.collisionDamageStarrStep.fromWhom',
    defaultMessage: 'It so, from whom?',
  },

  dateReimbursementReceived: {
    id: 'fastCover.collisionDamageStarrStep.dateReimbursementReceived',
    defaultMessage: 'Date Reimbursement Received',
  },

  estimatedValue: {
    id: 'fastCover.collisionDamageStarrStep.estimatedValue',
    defaultMessage: 'Estimated Value',
  },

  dateOfLoss: {
    id: 'fastCover.collisionDamageStarrStep.dateOfLoss',
    defaultMessage: 'Date Of Loss',
  },

  pleaseDescribeWhatOccurred: {
    id: 'fastCover.collisionDamageStarrStep.pleaseDescribeWhatOccurred',
    defaultMessage: 'Please Describe What Occurred',
  },

  placeOfLoss: {
    id: 'fastCover.collisionDamageStarrStep.placeOfLoss',
    defaultMessage: 'Place Of Loss',
  },

  itemDescription: {
    id: 'fastCover.collisionDamageStarrStep.itemDescription',
    defaultMessage: 'Item Description',
  },

  schoolName: {
    id: 'fastCover.collisionDamageStarrStep.schoolName',
    defaultMessage: 'School Name',
  },

  nameOfRentalCarCompany: {
    id: 'fastCover.collisionDamageStarrStep.nameOfRentalCarCompany',
    defaultMessage: 'Name of Rental Car Company',
  },

  expenseAmount: {
    id: 'fastCover.collisionDamageStarrStep.expenseAmount',
    defaultMessage: 'Expense Amount',
  },

  expenseFor: {
    id: 'fastCover.collisionDamageStarrStep.expenseFor',
    defaultMessage: 'Expense For',
  },

  selectInsuredForExpense: {
    id: 'fastCover.collisionDamageStarrStep.selectInsuredForExpense',
    defaultMessage: 'Select the Insured(s) for the expense',
  },
});



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.Starr.StepCollisionDamage/messages.js